import { ApiHandler, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, NavigateToReturnUrl } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { Cart, getCart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";

import {
    getSession as getSessionApi,
    Session,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getHomePageUrl, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { BillToModel, ShipToModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        billToId?: string;
        shipToId?: string;
        fulfillmentMethod: string;
        pickUpWarehouse: WarehouseModel | null;
        isDefault?: boolean;
        returnUrl?: string;
        skipRedirect?: boolean;
    } & HasOnSuccess &
        HasOnError<string>,
    UpdateSessionApiParameter,
    Session,
    {
        cart: Cart;
    }
>;

export const NavigateToReturnUrlExtended: HandlerType = async props => {
    if (props.parameter.skipRedirect) {
        return;
    }

    const state = props.getState();
    const session = getSession(state);
    const homePageUrl = getPageLinkByPageType(state, "HomePage")?.url;
    let languageSpecificLandingPage = session.customLandingPage;
    if (homePageUrl && homePageUrl !== "/") {
        if (languageSpecificLandingPage && languageSpecificLandingPage.startsWith("/")) {
            languageSpecificLandingPage = homePageUrl.concat(session.customLandingPage);
        } else {
            languageSpecificLandingPage = homePageUrl.concat("/", session.customLandingPage);
        }
    }
    const defaultUrl = session.dashboardIsHomepage
        ? getPageLinkByPageType(state, "MyAccountPage")?.url
        : session.customLandingPage
        ? languageSpecificLandingPage
        : "/MyAccount/RecentlyPurchasedItems";

    const checkoutShippingUrl = getPageLinkByPageType(state, "CheckoutShippingPage")?.url;
    let returnUrl = props.parameter.returnUrl;
    if (props.apiParameter.session.shipToId === "") {
        returnUrl = `${getPageLinkByPageType(state, "AddressesPage")?.url}?isNewShipTo=true`;
    } else if (returnUrl?.toLowerCase() === checkoutShippingUrl?.toLowerCase()) {
        const cartResult = await getCart({
            cartId: API_URL_CURRENT_FRAGMENT,
            expand: ["cartLines", "hiddenproducts"],
        } as GetCartApiParameter);
        const { canCheckOut, canBypassCheckoutAddress } = cartResult.cart;
        const checkoutReviewAndSubmitUrl = getPageLinkByPageType(state, "CheckoutReviewAndSubmitPage")?.url;
        const cartUrl = getPageLinkByPageType(state, "CartPage")?.url;
        if (!canCheckOut || session.isRestrictedProductExistInCart) {
            returnUrl = cartUrl;
        } else if (canBypassCheckoutAddress) {
            returnUrl = checkoutReviewAndSubmitUrl;
        }
    }

    window.location.href = returnUrl || defaultUrl || getHomePageUrl(state);
};

replaceInChain(chain, NavigateToReturnUrl, NavigateToReturnUrlExtended)